import { createContext, useContext } from "react";
import { DeviceThing } from "../types/DeviceThing.types";

interface MachinesContextType {
	machines: DeviceThing[];
	isLoading: boolean;
	setVisibleMachines: (thingNames: string[]) => void;
}

const MachinesContext = createContext<MachinesContextType>({
	machines: [],
	isLoading: true,
	setVisibleMachines: () => {},
});

export const useMachinesContext = () => useContext(MachinesContext);

export default MachinesContext;
